import React, {
  useEffect,
  useState,
  useCallback,
  useRef,
} from "react";
import { Col, Container, Row, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import store from "../../../../store/store";
import { BrComerceApiService } from "../../../../services/BrComerceApiService";
import { ChartBySla } from "./components/ChartBySla";
import { Loading } from "../../../../components/Loading";
import InputSelectAsync from "../../../../components/InputSelectAsync";
import InputSelect from "../../../../components/InputSelect";
import { GoogleMapsRoute } from "../../../../components/GoogleMapsRoute";
import FilterButton from "../../components/FilterButtons";

import useGetWindowWidth from "../../../../utils/useGetWindowWidth";
import ProfileEnum from "../../../../enums/ProfileEnum";
import ShippingStagesEnum from "../../../../enums/ShippingStagesEnum";
import { RouteStageEnum } from "../../../../enums/RouteStageEnum";
import { RouteShippingStageEnum } from "../../../../enums/RouteShippingStageEnum";
import styles from "./styles.module.scss";
import pinTruck from "../../../../assets/icons/pin-truck.svg";
import { RoutesSummaryCarousel } from "./components/RoutesSummaryCarrossel";
import DatePicker from "../../../../components/Input/DatePicker";
import { CartSimpleCardShipping } from "../../components/CartSimpleCardShipping";
import moment from "moment";

const DriverLocation = () => {
  const { auth } = store.getState();
  const { user } = auth;
  const isAdmin = user?.profile === ProfileEnum.ADMIN.value;

  const [center, setCenter] = useState({
    lat: -22.9035,
    lng: -43.2096
  })

  const api = new BrComerceApiService();
  const widthWindows = useGetWindowWidth();
  const intervalRef = useRef(null);
  const ongoingRequestRef = useRef(null);
  const pendingDriversRequests = useRef({});

  const [isLoading, setIsLoading] = useState(true);
  const [chartBySLA, setChartBySLA] = useState(null);
  const [searchDriver, setSearchDriver] = useState(null);
  const [searchPackage, setSearchPackage] = useState(null);
  const [searchStatus, setSearchStatus] = useState(null);
  const [resumeRoutes, setResumeRoutes] = useState([]);
  const [locations, setLocations] = useState([]);
  const [shippings, setShippings] = useState([]);
  const [shippingsExpand, setShippingsExpand] = useState([]);
  const [requestErrorsBalance, setRequestErrorsBalance] = useState([""]);
  const [selectedDate, setSelectedDate] = useState(moment().subtract(3, "hours").toDate());
  const [filters, setFilters] = useState();
  const [filterActionDisabled, setFilterActionDisabled] = useState(true);
  const [mustClear, setMustClear] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [driversWithLocation, setDriversWithLocation] = useState([]);
  const [searchClient, setSearchClient] = useState(null);

  const handleShippingExpand = useCallback(
    pack => {
      const find = shippingsExpand.find(p => p.id === pack.id);
      if (find) {
        const newPacks = shippingsExpand.filter(p => p.id !== pack.id);
        setShippingsExpand([...newPacks]);
      } else {
        shippingsExpand.push(pack);
        setShippingsExpand([...shippingsExpand]);
      }
    },
    [shippingsExpand]
  );

  const loadDashboard = async (props) => {
    try {
      setIsFetching(true);
      const { driverSubs, status, routeShippingStatus, clientSub } = props ?? {}

      const result = await api.makeHttpRequest({
        method: "GET",
        url: "/dashboard/adminIndicators/own-delivery",
        params: {
          date: selectedDate,
          driverSubs,
          status,
          routeShippingStatus,
          clientSub
        }
      });

      processChartBySLA(result);
      processRoutes(result.activeRoutes);
      processShippings(result.lastDeliveries);
      processLocations(result.locations);

      setRequestErrorsBalance([]);
      setDriversWithLocation([]);
    } catch (e) {
      handleErrors(e);
    } finally {
      setIsLoading(false);
      setIsFetching(false);
    }
  };

  const processChartBySLA = (chartData) => {
    setChartBySLA({
      date: selectedDate,
      totalActivedRoute: chartData.activeRoutes.length,
      ...chartData.chartBySLA,
    });
  };

  const processRoutes = (routes) => {
    setResumeRoutes(routes);
  };

  const processShippings = (lastDeliveries) => {
    setShippings(lastDeliveries);
  };

  const processLocations = (locationsData) => {
    const driverLocations = locationsData.drivers.map(driver => ({
      lat: driver?.lastLocation?.lat,
      lng: driver?.lastLocation?.lng,
      icon_type: "driver",
      code: `driver_${driver?.driver?.sub}`,
      driver_name: driver?.driver?.name,
      driver_sub: driver?.driver?.sub,
    }));

    const packageLocations = locationsData.routeShippings
      .filter(shipping => shipping?.shipping?.destination?.location) // Filtrar apenas pontos válidos
      .map(routeShipping => ({
        lat: routeShipping.shipping.destination.location.lat,
        lng: routeShipping.shipping.destination.location.lng,
        icon_type: "package",
        id: routeShipping.shipping.id,
        code: `shipping_${routeShipping.shipping.id}`,
        id_route: routeShipping.id_route,
        status: routeShipping.id_own_delivery_status,
        sro: routeShipping.shipping.sro,
        type: routeShipping.shipping.type,
      }));

    const ownCollectLocations = locationsData?.ownCollectRoutes
      .filter(routeOwnCollect => routeOwnCollect?.ownCollect?.collectAddress?.location) // Filtrar apenas pontos válidos
      .map(routeOwnCollect => {
        return ({
          lat: routeOwnCollect?.ownCollect?.collectAddress?.location?.lat,
          lng: routeOwnCollect?.ownCollect?.collectAddress?.location?.lng,
          icon_type: "ownCollect",
          id: routeOwnCollect?.ownCollect?.id,
          code: `ownCollect_${routeOwnCollect?.ownCollect?.id}`,
          id_route: routeOwnCollect?.id_route,
          status: routeOwnCollect?.id_own_delivery_status,
          sro: routeOwnCollect?.ownCollect?.id,
          type: "ownCollect",
          client: routeOwnCollect?.ownCollect?.user?.userData?.length ? routeOwnCollect?.ownCollect?.user?.userData[1]?.Value : undefined,
          startHour: routeOwnCollect?.ownCollect?.collectTimeStart,
          endHour: routeOwnCollect?.ownCollect?.collectTimeEnd
        })
      })

    setLocations([...ownCollectLocations, ...driverLocations, ...packageLocations]);
  };

  const handleErrors = (error) => {
    if (error?.message === "Sessão expirada!") {
      setRequestErrorsBalance(prev => [...prev, error.message]);
    } else {
      setRequestErrorsBalance(prev => [
        ...prev,
        "Ocorreu um erro ao carregar o dashboard",
      ]);
    }
  };

  const handleFilter = async () => {
    setIsLoading(true)
    if (ongoingRequestRef.current) {
      await ongoingRequestRef.current
      setIsLoading(true)
    }
    const newFilters = {
      driverSubs: searchDriver?.map(driver => driver.sub),
      status: searchStatus,
      routeShippingStatus: searchPackage,
      clientSub: searchClient?.sub
    }
    setFilters(newFilters)
    setFilterActionDisabled(true)
    await loadDashboard(newFilters);
  };

  const handleClear = async () => {
    setIsLoading(true)
    if (ongoingRequestRef.current) {
      await ongoingRequestRef.current
      setIsLoading(true)
    }
    setSearchDriver(undefined);
    setMustClear(true);
    setSearchStatus(undefined);
    setSearchPackage(undefined);
    setSearchClient(null);
    setSelectedDate(moment().subtract(3, "hours").toDate());
    setFilters(undefined)
    await loadDashboard();
  };

  const getDriverAddress = useCallback(async (loc) => {
    const { lat, lng, driver_sub } = loc;

    const driver_location = driversWithLocation.find(d => d.driver_sub === driver_sub);
    if (driver_location) {
      return driver_location;
    }

    if (pendingDriversRequests.current[driver_sub]) {
      return pendingDriversRequests.current[driver_sub];
    }

    const requestPromise = (async () => {
      try {
        const response = await api.makeHttpRequest({
          method: "GET",
          url: "/traccar-admin/get-address",
          params: { lat, lng }
        });

        if (response?.address) {
          setDriversWithLocation(prev => [...prev, { driver_sub, address: response.address }]);
        }
        return response;
      } catch (error) {
        return Swal.fire({
          title: 'Erro ao buscar dados!',
          text: 'Ocorreu uma falha ao buscar localização do motorista',
          icon: 'error'
        });
      } finally {
        delete pendingDriversRequests.current[driver_sub];
      }
    })();

    pendingDriversRequests.current[driver_sub] = requestPromise;
    return requestPromise;
  }, [driversWithLocation]);

  const statusOptions = Object.values(RouteStageEnum).map((stage) => ({
    value: stage.id,
    label: stage.message,
  }));

  const packageOptions = Object.values(RouteShippingStageEnum).map((stage) => ({
    value: stage.value,
    label: stage.label,
  }));

  function stopAutomaticFetch() {
    if (intervalRef?.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  const startAutomaticFetch = () => {
    stopAutomaticFetch();
    intervalRef.current = setInterval(() => {
      if (!isFetching) {
        ongoingRequestRef.current = loadDashboard(filters);
      }
    }, 15000); // 15 segundos
  };

  useEffect(() => {
    window.setPageTitle("Localização de Motoristas");

    async function loadInitialData() {
      setIsLoading(true)
      await loadDashboard(filters);
    }

    loadInitialData()
  }, []);

  useEffect(() => {
    stopAutomaticFetch()
    startAutomaticFetch()

    return () => stopAutomaticFetch
  }, [filters])

  useEffect(() => {
    if (filterActionDisabled) {
      setFilterActionDisabled(false)
    }
  }, [selectedDate, searchDriver, searchStatus, searchPackage, searchClient])

  useEffect(() => {
    if (requestErrorsBalance.length > 2) {
      Swal.fire({
        icon: "error",
        title: "Dashboard",
        text: requestErrorsBalance[requestErrorsBalance.length - 1]
      });
    }
  }, [requestErrorsBalance])

  return (
    <section className={styles.main}>
      <Loading loading={isLoading} />
      <h1>Localização de Motoristas</h1>
      <Container fluid className="pt-4">
        {chartBySLA ? (
          <ChartBySla data={chartBySLA} includeCollects={true} />
        ) : (
          <Row className={`${styles.cardsStatus}`}>
            <Col xs={12} className={styles.anErrorOcurred}>
              {isLoading ? (
                <Spinner animation="border" role="status">
                  <span style={{ visibility: "hidden" }}>Loading...</span>
                </Spinner>
              ) : (
                <p>Ocorreu um erro ao carregar indicadores.</p>
              )}
            </Col>
          </Row>
        )}
      </Container>


      <Container fluid className={styles.indicatorsCharts}>
        <div className={styles.filtersContainer}>
          <div className={styles.filter}>
            <InputSelectAsync
              search={searchDriver}
              setSearch={setSearchDriver}
              listUserOrDriver={"driver"}
              isMulti
              placeholder="Filtrar por motorista"
              mustClear={mustClear}
              setMustClear={setMustClear}
            />
          </div>
          {isAdmin && (
            <div className={styles.filter}>
              <InputSelectAsync
                search={searchClient}
                setSearch={setSearchClient}
                listUserOrDriver={"user"} 
                placeholder="Filtrar por cliente"
                mustClear={mustClear}
                setMustClear={setMustClear}
                />
            </div>
          )}
          <div className={styles.filter} style={{ marginTop: "-26px" }}>
            <InputSelect
              id="package-filter"
              options={packageOptions}
              value={packageOptions.find((option) => option.value === searchPackage) || null}
              onChange={(selectedOption) => setSearchPackage(selectedOption?.value || null)}
              placeholder="Status do Objeto"
            />
          </div>
          <div className={styles.filter} style={{ marginTop: "-26px" }}>
            <InputSelect
              id="status-filter"
              options={statusOptions}
              value={statusOptions.find((option) => option.value === searchStatus) || null}
              onChange={(selectedOption) => setSearchStatus(selectedOption?.value || null)}
              placeholder="Status da Rota"
            />
          </div>
          <div className={styles.filter}>
            <div className={styles.calendarInput}>
              <DatePicker
                className={"datePickerConfig"}
                change={(e) => setSelectedDate(e)}
                placeholder="Filtrar por período"
                defaultValue={selectedDate}
              />
            </div>
          </div>
          <div className={styles.actionButtonsContainer}>
            <div className={styles.filterAction}>
              <FilterButton onClick={handleFilter} variant="filter" disabled={filterActionDisabled} />
            </div>
            <div className={styles.filterAction}>
              <FilterButton onClick={handleClear} variant="clear" />
            </div>
          </div>
        </div>

        <Row>
          <Col className={styles.mapWrapper}>
            {!isLoading ? (
              <GoogleMapsRoute
                mapContext="driverDetails"
                zoom={11}
                centralizeCoordinates={center}
                locations={locations}
                iconMarker={pinTruck}
                visibleToggle={false}
                loadData={getDriverAddress}
              />
            ) : (
              <div className={styles.anErrorOcurred}>
                <Spinner animation="border" role="status">
                  <span style={{ visibility: "hidden" }}>Loading...</span>
                </Spinner>
              </div>
            )}
          </Col>
        </Row>
      </Container>

      <h1>Resumo de rotas diárias</h1>

      {!resumeRoutes.length ? (
        <div className={styles.nothingData}>
          {isLoading ?
            <Spinner animation="border" role="status">
              <span style={{ visibility: "hidden" }}>Loading...</span>
            </Spinner>
            :
            <span> Nenhuma rota encontrada</span>}
        </div>
      ) : <RoutesSummaryCarousel resumeRoutes={resumeRoutes} />}

      <h1 style={{ marginTop: "24px" }}>Últimas entregas</h1>

      <div className={styles.shippingsContainer}>
        {shippings?.length ? shippings?.map(pack => {
          return (
            <CartSimpleCardShipping
              widthWindows={widthWindows}
              key={pack?.ownCollect ? `${pack?.ownCollect?.id}-ownCollect` : pack?.shipping?.id}
              cardPackage={pack?.shipping || pack?.ownCollect}
              isSelected={false}
              isCancelled={
                pack.idShippingStatus === ShippingStagesEnum.OBJETO_CANCELADO.id
              }
              isAdmin={isAdmin}
              invoiceMethod={"null"}
              collectStage={4}
              edit={false}
              isExpand={shippingsExpand.find(
                shipExpand => pack.id === shipExpand.id
              )}
              onExpand={() => handleShippingExpand(pack)}
              select={false}
              delivery={pack?.delivery ?? {}}
              status={true}
            />
          );
        }) : <span className={styles.emptyDeliveries}>Nenhuma entrega encontrada</span>}
      </div>
    </section>
  );
};

export { DriverLocation };
